const IMAGE_SIZE = {
  WIDTH: 148,
  CDN_WIDTH: 219,
  GAP_FOR_IMAGE_SMALL: 16,
  GAR_FOR_IMAGE: 2,
};

const IMAGE_ASPECT_RATIO = 1.25;

export { IMAGE_SIZE, IMAGE_ASPECT_RATIO };
